import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { PUBLIC_SITE_URL } from "../config";
import { IconCalendar, IconGrid, IconStar, IconUsers } from "./ui";

const NAV = [
  { to: "/", label: "Overview", icon: IconGrid, end: true },
  { to: "/members", label: "Members", icon: IconUsers },
  { to: "/spotlight", label: "Spotlight", icon: IconStar },
  { to: "/events", label: "Events", icon: IconCalendar },
];

export default function Layout() {
  const { user, signOut } = useAuth();

  return (
    <div className="shell">
      <aside className="rail">
        <a
          className="rail-brand"
          href={PUBLIC_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="rail-mark" />
          <span className="rail-wordmark">
            <span className="l1">LEADERS CIRCLE</span>
            <span className="l2">UAE ADMIN</span>
          </span>
        </a>

        <div className="rail-section">Manage</div>
        <nav className="rail-nav">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `rail-link ${isActive ? "active" : ""}`}
            >
              <Icon />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="rail-foot">
          <div className="rail-user">
            <span className="rail-avatar">{(user?.name || "?").charAt(0).toUpperCase()}</span>
            <div style={{ minWidth: 0 }}>
              <div className="rail-user-name">{user?.name}</div>
              <div className="rail-user-role">{user?.role}</div>
            </div>
          </div>
          <button type="button" className="rail-signout" onClick={signOut}>
            Sign out
          </button>
        </div>
      </aside>

      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}

/** Sticky page header. Pages render this as their first child. */
export function PageHeader({ title, subtitle, children }) {
  return (
    <header className="topbar">
      <div>
        <h1>{title}</h1>
        {subtitle && <div className="topbar-sub">{subtitle}</div>}
      </div>
      {children && <div className="topbar-actions">{children}</div>}
    </header>
  );
}
